export default __webpack_public_path__ + "static/media/INXC front.5d695c4d.png";